// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e1a1149","239":"f7ba0b39","732":"e2024760"}[chunkId] + ".chunk.js";
};